'use client';

import { ComboboxInputGroup } from "../../combobox/input-group/ComboboxInputGroup.mjs";
/**
 * A wrapper for the input and its associated controls.
 * Renders a `<div>` element.
 *
 * Documentation: [Base UI Autocomplete](https://base-ui.com/react/components/autocomplete)
 */
export const AutocompleteInputGroup = ComboboxInputGroup;